module.exports = __webpack_public_path__ + "img/mail_icon.0bca7423.svg";